import { Sparkle28Filled } from "@fluentui/react-icons";

import styles from "./Answer.module.css";

export const AnswerIcon = () => {
    return <Sparkle28Filled className={styles.answerIcon} aria-hidden="true" aria-label="Answer logo" />;
};
